import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { WorkspaceService } from '../services/workspace.service';

export const workspaceGuard: CanActivateFn = (route, state) => {
  const workspaceService = inject(WorkspaceService);
  if (workspaceService.workspaceId == route.params['workspace']) return !!workspaceService.workspaceId;
  return workspaceService.loadWorkspace(route.params['workspace']);
};
